

















































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import DxPopup from 'devextreme-vue/popup';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import {
    CONTRACTS,
    FetchServiceContract,
    SettingsChangeServiceContract,
} from '@/core/contracts';
import { localize } from '@/core/filters';
import { Table } from '@/core/components/table';
import { DxSelectBox } from 'devextreme-vue';
import DxDropDownBox from 'devextreme-vue/drop-down-box';
import { DxButton } from 'devextreme-vue';
import {
    User,
    ClientSettingTypeEnum,
    Role,
    ContextUser,
    ContextSettings,
    ClientSettings,
    OffsetsBlockSettings,
} from '@/dto';
import { ContextsState, SettingsState, UserState } from '@/store';
import { SettingsChangeService } from '@/core/services/settingsChangeService';
import { NoCache } from '@/core/helpers';
import notify from 'devextreme/ui/notify';

interface IUserModel {
    id: number;
    name: string;
    role: Role;
}

interface IContextSettingsModel {
    contextType: string;
    currentTime: string;
    scheduleTime: string;
    settings: { [key: string]: string };
}

@Component({
    components: {
        DxPopup,
        DxSelectBox,
        DxDropDownBox,
        DxButton,
    },
})
export default class SaveForTypeOption extends Vue {
    @Prop() public table!: Table;
    @Prop(String) public tableKey!: string;

    public isAdmin: boolean = false;
    public isDropDownBoxOpened: boolean = false;
    public popupVisible: boolean = false;
    public inLoading: boolean = false;
    public currentContextUser!: ContextUser;
    public listUsers: Array<IUserModel> = [];
    public listRoles: Array<Role> = [];
    public selectedUserId: number = 0;
    public selectedRoleId: number | undefined = 0;
    public clientSettingType: number = -1;

    private clientSettings = [
        {
            value: 0,
            name: localize('ClientSettingType_ContextUser'),
        },
        {
            value: 2,
            name: localize('ClientSettingType_ContextRole'),
        },
        {
            value: 3,
            name: localize('ClientSettingType_Context'),
        },
    ];

    @Inject(CONTRACTS.FetchService)
    private _fetchService?: FetchServiceContract;

    public get localize() {
        return localize;
    }

    public showDialog() {
        this.popupVisible = true;
    }

    public async saveTableLayout() {
        const state = this.table.state();
        delete state.selectedRowKeys;
        const roleName = this.isAdmin ? this.listRoles.find(s => s.id === this.selectedRoleId)?.name :
                         undefined;
        const userId = this.isAdmin ? this.selectedUserId.toString() :
                       UserState.current!.id.toString();
        const settingType = this.isAdmin ? this.clientSettingType as ClientSettingTypeEnum :
                            ClientSettingTypeEnum.ContextUser;

        try {
            await this.settingsChangeService.changeTableLayoutSetting(
                this.tableKey,
                JSON.stringify(state),
                settingType,
                userId,
                roleName
            );
            notify(
                localize('UserSettingsComponent_ResultSuccess'),
                'success',
                3000
            );

            this.popupVisible = false;
        } catch (error) {
            notify(
                localize('UserSettingsComponent_ResultError'),
                'error',
                3000
            );
        }
    }

    private async mounted() {
        if (this.isAdmin) {
            await this.loadUsers();
            await this.loadRoles();

            await this.setCurrentContextUser();

            this.selectedUserId = this.currentContextUser.id;
            if (!this.currentContextUser.role) {
                const finedRole = this.listRoles.find(
                    s => s.name === 'Administrator'
                );
                this.selectedRoleId = finedRole ? finedRole.id : -1;
            } else {
                this.selectedRoleId = this.currentContextUser.role
                    ? this.currentContextUser.role.id
                    : -1;
            }
        }
        this.inLoading = false;
    }

    private async created(): Promise<void> {
        this.isAdmin = ContextsState.current!.own === true;
        await this.loadSettingsLevel();
    }

    private async setCurrentContextUser(): Promise<void> {
        const currentUser: User = UserState.current!;
        const currentUserId: number = Number(currentUser.id);

        this.currentContextUser = {
            id: currentUserId,
            name: currentUser.name!,
            email: currentUser.email,
            role: this.listUsers.find(u => u.id === currentUserId)?.role,
        };
    }

    private async loadSettingsLevel(): Promise<void> {
        if (ContextsState.current!.contextType) {
            const addedArray = [
                {
                    value: 1,
                    name: localize('ClientSettingType_UserOfContextType'),
                },
                {
                    value: 4,
                    name: localize('ClientSettingType_ContextType'),
                },
            ];
            this.clientSettings.push(...addedArray);
        }
    }

    private async loadRoles(): Promise<void> {
        const contextId = ContextsState.currentContextId;
        const url = '/contexts/' + contextId + '/roles';
        this.listRoles = await this._fetchService!.get<Role[]>(url);
    }

    private async loadUsers(): Promise<void> {
        const currentContextId = ContextsState.currentContextId;
        const loadedSettings = await this._fetchService!.get<Array<IUserModel>>(
            '/contexts/' + currentContextId + '/users'
        );
        this.listUsers = loadedSettings;
    }

    @NoCache
    private get settingsChangeService(): SettingsChangeServiceContract {
        return SettingsState.changeService!;
    }
}
